var map = {
	"./amex.png": "kWYj",
	"./cal.png": "XMvm",
	"./diners_visacal.png": "34ai",
	"./isracard.png": "C04K",
	"./leumicard.png": "n7QD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "y7Tn";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards ^\.\/.*$
// module id = y7Tn
// module chunks = 6